
export class CopyRoundParameters {
	roundId: number = 0;
	truckerId: number = 0;
	roundNotes: string = '';
	internalComments: string = '';
	periodStartDate: string = '';
	periodEndDate: string = '';
	dispatches: CopyRoundItem[] = [];
}

export class CopyRoundItem {
	dispatchId: number = 0;
	loads: number = 0;
	loadNumber: string = '';
	unloadNumber: string = '';
	rate: string = '';
}
